import { Media } from "@pathwright/media-utils"
import Fuse from "fuse.js"

type FuseOptions = Fuse.IFuseOptions<Media>

export const fuseOptions: FuseOptions = {
  keys: ["name", "description", "tags"],
  threshold: 0.3,
  shouldSort: false,
  minMatchCharLength: 2
}

const fuseSearch = (
  list: Media[],
  term: string,
  options: FuseOptions
): Media[] => {
  const fuse = new Fuse<Media>(list, options)

  return fuse.search(term).map((result) => result.item)
}

export default fuseSearch
